import Validator from 'validatorjs';
import { checkout } from './rules';

const validateCheckout = (values) => {

  const validation = new Validator(values, checkout);
  validation.setAttributeNames({
    cardNumber: 'card number',
    cardName: 'card name',
    cardExpirationMonth: 'card expiration month',
    cardExpirationYear: 'card expiration year',
    cardCVC: 'card cvc',
  });

  let errors = {};
  if (!validation.passes()) {
    errors = validation.errors.all();
  }

  return runCustomValidations(values, errors);
};

const runCustomValidations = (values, errors) => {

  //validatorjs can handle min/max length fields but it would have been weird with the credit card field because it has spaces in it too
  //also in the future i plan to tweak this to pay attention to what kind of card it is and validate the length more properly based on that
  let cardNumber = values.cardNumber;
  if (cardNumber) {
    let normalizedNumber = cardNumber.replace(/ /g, '');
    if (normalizedNumber.length < 13) {
      errors.cardNumber = ['The card number must be at least 13 digits'];
    } else if (normalizedNumber.length > 16) {
      errors.cardNumber = ['The card number cannot exceed 16 digits'];
    }
  }

  if (values.cardCVC) {
    if (values.cardCVC.length < 3) {
      errors.cardCVC = ['The card cvc must be at least 3 digits'];
    } else if (values.cardCVC.length > 4) {
      errors.cardCVC = ['The card number cannot exceed 4 digits'];
    }
  }

  if (!values.authBillingAmount) {
    errors.authBillingAmount = ['Please authorize this payment'];
  }

  return errors;
};

export {
  validateCheckout
};
